import { addPDFOpenButton } from './addPDFOpenButton'
import { wrapAttachElement } from './wrapAttachElement'

export const createPdfOpenButtonIfNotExist = (element: HTMLDivElement, clickHandler: (url: string) => void) => {
  if (element) {
    element.querySelectorAll('.attach').forEach((item) => {
      if (item?.parentElement?.classList.contains('attach__container')) {
        return
      }

      wrapAttachElement(item as HTMLAnchorElement)

      const url = (item as HTMLAnchorElement).href
      const extension = url?.split?.('.').reverse?.()?.[0]
      const isPdf = extension === 'pdf'

      if (isPdf) {
        addPDFOpenButton(item.parentElement as HTMLDivElement, (item as HTMLAnchorElement).href, clickHandler)
      }
    })
  }
}
